export const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5455 16.1705C19.1062 16.6098 18.3938 16.6098 17.9545 16.1705L12 10.216L6.04549 16.1705C5.60616 16.6098 4.89384 16.6098 4.45451 16.1705C4.01517 15.7312 4.01517 15.0188 4.45451 14.5795L11.2045 7.8295C11.6438 7.39016 12.3562 7.39016 12.7955 7.8295L19.5455 14.5795C19.9848 15.0188 19.9848 15.7312 19.5455 16.1705Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
)